module.exports = __webpack_public_path__ + "static/media/IMG_0554.607aecd6.JPG";